import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { Bloomerang } from 'assets/js/pages/account-settings/account-integrations/Bloomerang';
import { Chariot } from 'assets/js/pages/account-settings/account-integrations/Chariot';
import { DonorSearch } from 'assets/js/pages/account-settings/account-integrations/DonorSearch';
import { DoubleDonation } from 'assets/js/pages/account-settings/account-integrations/DoubleDonation';
import { Facebook } from 'assets/js/pages/account-settings/account-integrations/Facebook';
import { GoogleAnalytics } from 'assets/js/pages/account-settings/account-integrations/GoogleAnalytics';
import { Mailchimp } from 'assets/js/pages/account-settings/account-integrations/Mailchimp';
import { ThankView } from 'assets/js/pages/account-settings/account-integrations/ThankView';
import { Settings } from 'constants/settings';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useFlags } from 'launchdarkly-react-client-sdk';

const Integrations = () => {
    const { chariot = false } = useFlags();
    const { settings } = useCurrentAccount();
    const customSubscription = settings.find(
        item => item.code === Settings.CustomSubscription.Code,
    );

    return (
        <Box className="flex flex-col gap-4 p-8">
            <Bloomerang />
            <Separator />

            {chariot ? (
                <>
                    <Chariot />
                    <Separator />
                </>
            ) : null}

            <ThankView />
            <Separator />

            <DonorSearch />
            <Separator />

            <DoubleDonation />
            <Separator />

            {customSubscription?.active ? (
                <>
                    <Mailchimp />
                    <Separator />
                </>
            ) : null}

            <GoogleAnalytics />
            <Separator />

            <Facebook />
        </Box>
    );
};

export { Integrations };
